import { Alert, Button, CircularProgress, LinearProgress, Typography } from '@mui/material';
import { useContext, useEffect, useState } from 'react';
import { OrderType } from '../../../../interfaces/delivery-company/orders';
import axios, { AxiosResponse } from 'axios';
import { API_ENDPOINT } from '../../../../configurations/global.config';
import { AuthContext } from '../../../../contexts/user-context/user-context';
import { CustomerType } from '../../../../interfaces/common/customer';
import { emptyOrder } from '../../../delivery-company-components/orders/create-order-form/create-order-form.utils';
import MonetizationOnIcon from '@mui/icons-material/MonetizationOn';
import { ErrorsFlattenner } from '../../errors-flattenner/errors-flattenner';
import MoneyInput from '../../money-input/money-input';
import { Money } from '../../../../utils/money';
import { get_cod } from '../../../../utils/cod';
import { Workflow } from '../../../../enums/orders';
import { isMobile, isTablet } from 'react-device-detect';
import { useSnackBar } from '../../../../contexts/snackbar';
import { LabelValueWithKey } from '../../../../interfaces/delivery-company/labels';
import {
  calculateBaseDeliveryFee,
  updateDeliveryFee,
} from '../../../../utils/order';
import { Dayjs } from 'dayjs';

interface CodUpdateFormProps {
  order: OrderType;
  onSuccess: (m: Money[]) => void;
}

function CodUpdateForm({ order, onSuccess }: CodUpdateFormProps) {
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const [loadingMessage, setLoadingMessage] = useState<string>('');
  const [response, setResponse] = useState<AxiosResponse>();
  const [message, setMessage] = useState<string>('');
  const [cod, setCod] = useState<Money[]>(get_cod(order));
  const { showMessage } = useSnackBar();
  const { config } = useContext(AuthContext);

  console.log('current order = ', JSON.stringify(order));
  console.log('current order = ', cod);

  useEffect(() => {
    setCod(get_cod(order));
    console.log('current order = ', cod);
  }, []);
  console.log('current order = ', cod);

  const handleSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    if (!order.id) {
        setMessage('Something Went Wrong');
        showMessage('Something went wrong. Please contact us.', 'error');
        return;
    }
    setIsLoading(true);
    setResponse(undefined);
    setLoadingMessage('Saving COD...');

    try {
      const response = await axios.post(
        `${API_ENDPOINT}/api/v1/order/${order.id}/cod/`,
        { cod: cod },
        config
      );
      setMessage('COD updated successfully');
      setResponse(response);
      onSuccess(cod);
    } catch (e) {
      if (axios.isAxiosError(e)) {
        setResponse(e.response);
        setMessage('Failed to save cod: ' + e.response?.statusText);
      } else {
        setMessage('Failed to save cod');
      }

      showMessage('Failed to save COD', 'error');
      console.log(e);
    }
    setIsLoading(false);
    setLoadingMessage('');
  };

  console.log('check cod here: ', cod);

  return (
    <>
      <Typography
        variant="h3"
        component="h3"
        sx={{ textAlign: 'center', mt: 3, mb: 3 }}
      >
        Edit COD
      </Typography>

      <Typography align='center' variant='body2'>Order #{order.order_id} - {order.customer?.name}</Typography>

      {isLoading ? (
        <>
          {loadingMessage}
          <br />
          <CircularProgress />
        </>
      ) : (
        <>
          {message !== '' && (
            <Alert
              severity={
                response && response.status >= 200 && response.status < 300
                  ? 'success'
                  : 'error'
              }
            >
              <>
                {message}

                {response && response.status >= 300 && (
                  <ErrorsFlattenner rawErrors={response.data} />
                )}
              </>
            </Alert>
          )}

          <>
            <br></br>
            <form onSubmit={handleSubmit}>
              <>
                <MoneyInput
                  money={cod}
                  setMoney={(m) => setCod(m)}
                  label={'Collect on Delivery'}
                  icon={<MonetizationOnIcon color={'primary'} />}
                />
                <br />
                <div
                  style={{
                    display: 'flex',
                    justifyContent: 'flex-end',
                    gap: 8,
                  }}
                >
                  <Button
                    size={(isMobile && !isTablet) ? 'small' : 'medium'}
                    type="submit"
                    variant="contained"
                    color="primary"
                    disabled={order.workflow != Workflow.STANDARD}
                  >
                    Save COD
                  </Button>
                </div>
              </>
            </form>
          </>
        </>
      )}
    </>
  );
}

export default CodUpdateForm;
